import StartContract from '@/components/start-contract'
const processApi = require('@/api/process')
import dayjs from 'dayjs'
export default {
  components: { StartContract },
  data() {
    return {
      contractDialogShow: false,
      contractDialogGoodsShow: false,
      contractDialogData: null,
    };
  },
  methods: {
    contractComplete(res, callback, processParams) {
      // 发起合同完成后的回调
      console.log('contractComplete... ', res, callback)
    },
    openContractDialog(item,contractId) {

      let spStatusMessage = null
      if (item.contractSpStatus === 3) {
        spStatusMessage = '被驳回'
      } else if (item.contractSpStatus === 4) {
        spStatusMessage = '已撤回'
      }
      if (contractId && spStatusMessage) {
        this.$confirm(`该合同审批流程${spStatusMessage}，是否重新发起合同审批流程？`, {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          // 是
          this.innerOpenContractDialog(item, null)
        }).catch(() => {
          // 否
          this.innerOpenContractDialog(item, contractId)
        })
        return
      }

      this.innerOpenContractDialog(item, contractId)
    },
    innerOpenContractDialog(item,contractId) {
      console.log('item===>1',item)
      console.log('contractId===>1',contractId)

      this.contractDialogData = item
      // 打开合同iframe
      this.contractDialogShow = true
      let ref = this.$refs.startContract
      if(ref) {
        if(contractId) {
          ref.title = '查看合同'
        }else {
          ref.title = '创建合同'
        }
        if (item.contractSpStatus) {
          ref.spStatus = item.contractSpStatus
        } else {
          ref.spStatus = null
        }
        ref.contractId = contractId
      }
    },
    innerOpenContractDialogGoods(item,contractId) {
      this.contractDialogData = item
      // 打开合同iframe
      this.contractDialogGoodsShow = true
      let ref = this.$refs.startContractGoods
      if(ref) {
        if(contractId) {
          ref.title = '查看合同'
        }else {
          ref.title = '创建合同'
        }
        if (item.contractSpStatus) {
          ref.spStatus = item.contractSpStatus
        } else {
          ref.spStatus = null
        }
        ref.contractId = contractId
        ref.tplModule = 4;
      }
    },
    setContractDialogPayload(cb) {
      // 设置发起合同时传递给合同iframe的payload
      // 默认实现，如果需要自定义的场景，在调用的地方覆盖该方法即可
    },
    // 第三方审批系统同步流程
    async syncThirdSystemProcess(processParams, callback) {
      let arr = []
      if (callback.shipNameStr) {
        arr.push('船名：'+callback.shipNameStr)
      }
      if (callback.shipTime) {
        arr.push('船期：'+dayjs(callback.shipTime).format('MM/DD'))
      }
      if (callback.dingjin) {
        arr.push('定金：'+callback.dingjin)
      }
      if (callback.shipPayStr) {
        arr.push('运价：'+callback.shipPayStr)
      }
      if (!processParams) {
        processParams={}
      }
      if (!processParams.briefContent) {
        processParams.briefContent=''
      }
      processParams.briefContent = arr.join('，')+'，' + processParams.briefContent
      let res = await processApi.saveProcess('contractFlow', processParams)
      console.log(res)
    }
  },
};
